import { isMatchFormatType, MatchFormat } from "model/Match/MatchFormat";
import { FsMatchFormat } from "db/model/match/FsMatchFormat";

export const mapMatchFormat = (
  fsModel: FsMatchFormat
): MatchFormat | undefined => {
  if (!isMatchFormatType(fsModel.type)) {
    return undefined;
  }

  if (fsModel.type === "Single") {
    return {
      type: "Single",
    };
  }

  if (!fsModel.amount) {
    return undefined;
  }

  return {
    amount: fsModel.amount,
    setAdvantageRosterIds: fsModel.setAdvantageRosterIds,
    setPoints: fsModel.setPoints,
    tiebreakerSet: fsModel.tiebreakerSet ?? false,
    type: fsModel.type,
  };
};
